import { NgModule } from '@angular/core';
import {CalculatorsComponetsRouting} from './components-routes/calculators-componets-routes';
import {NgxElementModule} from './components/ngx-element/ngx-element.module';
import {CoreComponetsRouting} from './components-routes/core-componets-routes';

const componetsClass: any = [
  CalculatorsComponetsRouting,
  CoreComponetsRouting
];

function getComponents(): any[]{
  let array = [];
  for (const clas of componetsClass) {
    array = array.concat(clas.components);
  }
  return array;
}

@NgModule({
  imports: [NgxElementModule.forRoot(getComponents())],
  exports: [NgxElementModule]
})
export class AppRoutingModule { }